import classNames from "classnames";
import React, { useEffect } from "react";
import { useState } from "react";
import { Title } from "../open-title";
import { useTranslation } from "react-i18next";
import {
  AuthingButton,
  AuthingButtonArrow,
} from "../../components/AuthingButton";
// import LinkLine from "../open-linkline";
import "./styles.less";

const downloadFile = (fileUrl, fileName) => {
  const iframe = document.createElement("iframe");
  iframe.src = fileUrl;
  iframe.style.display = "none";
  iframe.name = fileName;

  document.body.appendChild(iframe);
  return new Promise((resolve, reject) => {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    if (
      iframeDoc.readyState === "complete" ||
      iframeDoc.readyState === "interactive"
    ) {
      resolve(true);
    }
  });
};

export const Playground = () => {
  const { t } = useTranslation();

  const playgrounds = [
    {
      tab: t("open.playground.tab.b2c"),
      key: "b2c",
      title: "音乐平台项目",
      desc:
        "本文将以一个 Github 上开源的在线听歌项目为例，将 Authing 的多种功能接入到 B2C 的系统。帮助你快速开启数字化征程~",
      content:
        "本项目的技术栈主要是 Spring Boot + Vue3 + MySQL，一个在线听歌项目以及其后台管理系统，其中普通用户可以在客户端进行账号的注册、登录以及歌曲的播放、收藏、点赞、评论；管理员可以在后台进行账号、角色、数据的管理。",
      imgSrc: "//files.authing.co/authing-website/open/playground-b2c.jpg",
      tryLink: "https://playground-b2c-client.authing.co/",
      downloadLink:
        "//files.authing.co/authing-website/open/music-website-master.zip",
      downloadName: "音乐平台项目",
      detail: "/developer/b2c",
    },
    {
      tab: t("open.playground.tab.b2e"),
      key: "b2e",
      title: "人事管理系统",
      desc:
        "本文将以一个 Github 上开源的人事管理系统为例，介绍如何接入 Authing 服务到一个企业管理系统，帮助你快速开启数字化征程~",
      content:
        "本项目的技术栈主要是 Spring Boot + Vue2 + MySQL + Redis + Spring Security，一个企业级的人事管理系统，其中管理员可以根据不同角色对企业进行人事管理、人员资料管理、财务管理等操作。",
      imgSrc: "//files.authing.co/authing-website/open/playground-b2e.jpg",
      tryLink: "https://playground-b2e.authing.co",
      downloadLink: "//files.authing.co/authing-website/open/vhr-master.zip",
      downloadName: "人事管理系统",
      detail: "/developer/b2e",
    },
    {
      tab: t("open.playground.tab.b2b"),
      key: "b2b",
      title: "周报系统项目",
      desc:
        "本文将以一个 Github 上开源的周报管理系统为例，将 Authing 的多租户服务接入企业内部系统。帮助你快速开启数字化征程~",
      content:
        "周报系统的技术栈主要是 Node + Vue + Redis + MySQL + ES6，一个企业管理系统。企业员工汇报每周工作计划以及完成情况，各级负责人可以按权限查看，并向未填写周报人员发送提醒。数据库使用 MySQL，后端基于 Node 的 ThinkJS 框架搭建。",
      imgSrc: "//files.authing.co/authing-website/open/playground-b2b-02.jpg",
      tryLink: "https://playground-b2b.authing.co",
      downloadLink:
        "//files.authing.co/authing-website/open/Playground-ToB-main.zip",
      downloadName: "周报系统项目",
      detail: "/developer/b2b",
    },
    {
      tab: t("open.playground.tab.m2m"),
      key: "m2m",
      title: "机器间授权",
      desc:
        "本文将以一个简单的 M2M 授权 Demo 为例，介绍如何将 Authing 服务接入系统，实现 M2M 场景需求，帮助你快速开启数字化征程~",
      content:
        "本项目前端使用 Vue，后端使用 Node 开发。通过在 Authing 控制台新建应用，创建编程账号，同时为编程账号分配接口资源，完成对编程账号的权限控制，实现机器间授权。",
      imgSrc: "//files.authing.co/authing-website/open/playground-m2m.jpg",
      tryLink: "https://playground-m2m.authing.co",
      downloadLink:
        "//files.authing.co/authing-website/open/Playground-M2M-main.zip",
      downloadName: "机器间授权",
      detail: "/developer/m2m",
    },
  ];

  const [checked, setChecked] = useState(playgrounds[0]);
  const [isMobile, setMobile] = useState(false);

  const computeIsMobile = () => {
    const width =
      document.body?.clientWidth || document.documentElement?.clientWidth;
    if (width < 768) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    computeIsMobile();
    window.addEventListener("resize", computeIsMobile);
    return () => {
      window.removeEventListener("resize", computeIsMobile);
    };
  }, []);

  return (
    <div className="open-page-playground">
      <Title title={t("open.playground.title")} />
      <div className="open-page-playground-tabs">
        {playgrounds.map((item) => {
          return (
            <div
              className={classNames(
                "open-page-playground-tab",
                checked.key === item.key && "open-page-playground-tab--checked"
              )}
              onClick={() => {
                setChecked(item);
              }}
            >
              {item.tab}
            </div>
          );
        })}
      </div>
      <div className="basic-column">
        <div className="open-page-playground-card">
          <h2>
            {checked.title}
            {/* <LinkLine /> */}
            {/* <a
              className="open-page-playground-card-link"
              target="_blank"
              rel="noopener noreferrer"
              href={checked.detail} // TODO 需要填写 playground 链接
            >
              <span>{t("open.playground.check")}</span>
              <i className="icon authing-icon authing-arrow-right-s-line"></i>
            </a> */}
          </h2>
          <div className="open-page-playground-card-content">
            {!isMobile && (
              <div
                className="open-page-playground-card-content-img"
                style={{
                  background: `url(${checked.imgSrc})`,
                }}
              ></div>
            )}
            <div className="open-page-playground-card-content-desc">
              <div className="open-page-playground-desc">{checked.desc}</div>
              {!isMobile && (
                <div className="open-page-playground-title">
                  {t("open.playground.background")}
                </div>
              )}
              {isMobile && (
                <div
                  className="open-page-playground-card-content-img"
                  style={{
                    background: `url(${checked.imgSrc})`,
                  }}
                ></div>
              )}
              <div className="open-page-playground-content">
                {checked.content}
              </div>
              <div className="open-page-playground-card-buttons">
                <AuthingButton
                // onClick={() => {
                //   downloadFile(checked.downloadLink, checked.downloadName);
                // }}
                >
                  {t("open.playground.download")}
                </AuthingButton>
                {/* <AuthingButtonArrow
                  onClick={() => {
                    window.open(checked.tryLink);
                  }}
                >
                  {t("open.playground.try")}
                </AuthingButtonArrow> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
